import { Building2Icon } from "lucide-react";
import { Link } from "react-router";

import { CompanyLogoImage, Column, Row, Text } from "@/components";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { type PortfolioMatrixJob } from "@/hooks/queries/portfolio/useGetPortfolioMatrix";

export const JobCell = ({ job }: { job: PortfolioMatrixJob }) => {
  return (
    <Row className="min-w-0 items-center gap-3">
      {job.companySmallLogoUrl || job.companyLogoUrl ? (
        <Row className="h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-md border border-slate-200 bg-slate-50">
          <CompanyLogoImage
            companyName={job.companyName}
            logoUrl={job.companyLogoUrl}
            smallLogoUrl={job.companySmallLogoUrl}
            fallback={<Building2Icon className="h-5 w-5 text-slate-400" />}
          />
        </Row>
      ) : (
        <Tooltip>
          <TooltipTrigger asChild>
            <Link
              to={`/companies/${job.companyId}?t=profile`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-md border border-dashed border-slate-200 bg-slate-50 hover:border-slate-300 hover:bg-slate-100"
            >
              <Building2Icon className="h-5 w-5 text-slate-400" aria-hidden />
            </Link>
          </TooltipTrigger>
          <TooltipContent>Add company logo</TooltipContent>
        </Tooltip>
      )}
      <Column className="min-w-0 gap-0.5">
        <Text className="truncate text-sm font-medium" variant="primary">
          {job.title}
        </Text>
        <Text className="truncate text-sm" variant="muted">
          {job.companyName}
        </Text>
      </Column>
    </Row>
  );
};
